import React from 'react';
import './AdminTh.css';

/**
 * @param {{
 *   children?: React.ReactNode,
 *   sortable?: boolean,
 *   sortDirection?: 'asc' | 'desc' | null,
 *   onSort?: (() => void) | null,
 *   className?: string
 * } & React.ThHTMLAttributes<HTMLTableCellElement>} props
 */
function AdminTh({
  children,
  sortable = false,
  sortDirection = null,
  onSort = null,
  className = '',
  ...rest
}) {
  const chevron = sortDirection === 'asc' ? '▴' : '▾';

  return (
    <th className={`au-th au-scope${className ? ` ${className}` : ''}`} {...rest}>
      {sortable ? (
        <button type="button" className="au-th__button" onClick={onSort}>
          <span>{children}</span>
          <span className={`au-th__chevron${sortDirection ? ' is-active' : ''}`} aria-hidden="true">
            {chevron}
          </span>
        </button>
      ) : (
        <span className="au-th__label">{children}</span>
      )}
    </th>
  );
}

export default AdminTh;
